module.exports = __webpack_public_path__ + "static/media/your-flower-popup-sp.46f352ff.jpg";